import React from "react";

import {NAVIGATION_BAR_HEIGHT} from "../../designSystem/tokens/spacing";
import {OrganizationListFeature} from "../../features/organizationList";
import {FormPageLayout} from "../../components/layout/FormPageLayout";

const OrganizationListPage = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.EMPTY}
    body={
      <OrganizationListFeature />
    }
  />
)

export default OrganizationListPage;
